import React, { Component } from "react";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import { ValidationForm, TextInput } from "react-bootstrap4-form-validation";
import swal from "sweetalert";
import LoadingOverlay from "react-loading-overlay";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../../../BaseUrlApi/Url";
import {
  normalizePhoneNumber,
  isValidPhoneNumber,
} from "../../../../utils/phoneNumber";
import {
  apiErrorMessage,
  NURSE_FIELD_LABELS,
} from "../../../../utils/apiError";
import "./UpdateUser.css";

const headers = {
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  "Content-Type": "application/json",
};

class UpdateUser extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      isLoaded: false,
      immediate: true,
      setFocusOnError: true,
      clearInputOnReset: false,
      isSaving: false,
      nurseId: null,
      gender: [],
      choose_gender: {},
      // "" rather than null: these back controlled TextInputs, and null makes
      // React flip them from uncontrolled to controlled once data loads.
      name: "",
      startDate: new Date(),
      birthdate: null,
      birthplace: "",
      address: "",
      phonenumber: "",
    };
  }
  async componentDidMount() {
    this.getGender();
    this.getUserData();
  }

  getUserData = async () => {
    this.setState({ isLoaded: true });
    let userId = this.props.match.params.value;
    try {
      let getUser = await axios.get(`${API_URL}/admin/users/${userId}`, {
        headers,
      });
      const nurse = getUser.data.user.nurse;

      // A user whose nurse profile failed to save has no row here. That used
      // to throw before the page ever rendered.
      if (!nurse) {
        this.setState({ isLoaded: false });
        swal({
          title: "GAGAL",
          text:
            "Data perawat untuk akun ini tidak ditemukan. Hapus akun ini lalu daftarkan ulang.",
          icon: "warning",
          buttons: "OK",
        }).then(() => {
          window.location.href = "/users";
        });
        return;
      }

      this.setState({
        name: nurse.name,
        birthplace: nurse.birthplace,
        birthdate: nurse.birthdate,
        address: nurse.address,
        phonenumber: nurse.phone_number,
        nurseId: nurse.id,
        // Read straight off the response: `this.state` is not updated yet at
        // this point, and the field is `gender`, not `bef_gender` - between
        // them, every nurse used to load as "Perempuan" and got silently
        // saved that way.
        choose_gender:
          nurse.gender === "male"
            ? { value: "male", label: "Laki-laki" }
            : { value: "female", label: "Perempuan" },
        isLoaded: false,
      });
    } catch (err) {
      this.setState({ isLoaded: false });
      swal({
        title: "GAGAL",
        text: apiErrorMessage(err, NURSE_FIELD_LABELS),
        icon: "warning",
        buttons: "OK",
      });
    }
  };

  getGender = async () => {
    let gender = [
      {
        gender: "male",
        label: "Laki-laki",
      },
      {
        gender: "female",
        label: "Perempuan",
      },
    ];

    let getGender = gender.map((type) => ({
      value: type.gender,
      label: type.label,
    }));

    this.setState({
      gender: getGender,
    });
  };

  genderHandler = async (value) => {
    this.setState({
      choose_gender: {
        value: value.value,
        label: value.label,
      },
    });
  };

  selectedDate = (value) => {
    if (this.state.birthdate === null) {
      return "";
    } else {
      return new Date(this.state.birthdate);
    }
  };

  dateHandler = async (date) => {
    this.setState({
      startDate: date,
    });
    // Deliberately `date`, not `this.state.startDate`: setState has not
    // committed yet here, so reading state back saved the *previously*
    // picked date.
    if (date !== null) {
      this.dateConverter(date);
    } else {
      this.setState({ birthdate: null });
    }
  };

  dateConverter = (value) => {
    let date = value,
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    let convertDate = [date.getFullYear(), mnth, day].join("-");
    this.setState({
      birthdate: convertDate,
    });
  };

  inputHandler = async (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validPhoneNumber = (value) => {
    return isValidPhoneNumber(value);
  };

  genderHandler = async (value) => {
    this.setState({
      choose_gender: {
        value: value.value,
        label: value.label,
      },
    });
  };

  saveUser = async (e) => {
    e.preventDefault();

    if (!this.state.choose_gender.value) {
      swal({
        title: "GAGAL",
        text: "Jenis kelamin harus dipilih",
        icon: "warning",
        buttons: "OK",
      });
      return;
    }
    if (!this.state.birthdate) {
      swal({
        title: "GAGAL",
        text: "Tanggal lahir harus diisi",
        icon: "warning",
        buttons: "OK",
      });
      return;
    }

    const datas = {
      _method: "PATCH",
      name: this.state.name,
      gender: this.state.choose_gender.value,
      birthdate: this.state.birthdate,
      birthplace: this.state.birthplace,
      phone_number: normalizePhoneNumber(this.state.phonenumber),
      address: this.state.address,
    };

    this.setState({ isSaving: true });
    try {
      await axios.post(`${API_URL}/admin/nurses/${this.state.nurseId}`, datas, {
        headers,
      });
      const move = await swal({
        title: "Sukses!",
        text: "Data Perawat Telah Berhasil Diubah!",
        icon: "success",
        button: "OK",
      });
      if (move) {
        window.location.href = `/users`;
      }
    } catch (err) {
      swal({
        title: "GAGAL",
        text: apiErrorMessage(err, NURSE_FIELD_LABELS),
        icon: "warning",
        buttons: "OK",
      });
    } finally {
      this.setState({ isSaving: false });
    }
  };

  render() {
    let { isLoaded, name, birthplace, address, phonenumber } = this.state;
    return (
      <>
                <LoadingOverlay active={isLoaded} spinner text="Memuat data...">
          <div className="content-section">
            <div className="title-section mb-5">
              <h1 className="patient-page-title">Ubah Pengguna</h1>
              <h2 className="patient-page-subtitle">
                <span style={{ color: "#039BEB" }}>Manajemen Pengguna</span>
                <span style={{ color: "#00000029" }}> / Ubah Pengguna</span>
              </h2>
            </div>
            <div className="card shadow mb-4">
              <div className="card-body">
                <ValidationForm
                  onSubmit={this.saveUser}
                  ref={this.formRef}
                  immediate={this.state.immediate}
                  setFocusOnError={this.state.setFocusOnError}
                >
                  <table cellPadding="10" className="add-table text-left pl-2">
                    <tbody>
                      <tr>
                        <td colSpan="2">
                          <p className="account-title ml-2">Data Pribadi</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label htmlFor="" className="label-update">
                            Nama
                          </label>
                        </td>
                        <td>
                          
                          :
                          <TextInput
                            type="text"
                            name="name"
                            value={name}
                            required
                            errorMessage={{ required: "Nama harus diisi" }}
                            onChange={this.inputHandler}
                            className="add-vaccine-input"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label htmlFor="" className="label-update">
                            Jenis Kelamin
                          </label>
                        </td>
                        <td>
                          
                          :
                          <Select
                            options={this.state.gender}
                            value={
                              this.state.choose_gender.value
                                ? this.state.choose_gender
                                : null
                            }
                            onChange={(value) => this.genderHandler(value)}
                            placeholder="Pilih jenis kelamin..."
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label htmlFor="" className="label-update">
                            Tempat Lahir
                          </label>
                        </td>
                        <td>
                          
                          :
                          <TextInput
                            type="text"
                            name="birthplace"
                            value={birthplace}
                            required
                            errorMessage={{
                              required: "Tempat lahir harus diisi",
                            }}
                            onChange={this.inputHandler}
                            className="add-vaccine-input"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label htmlFor="" className="label-update">
                            Tanggal Lahir
                          </label>
                        </td>
                        <td>
                          
                          :
                          <DatePicker
                            selected={this.selectedDate()}
                            onChange={this.dateHandler}
                            dateFormat="dd-MM-yyyy"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label htmlFor="" className="label-update">
                            Alamat
                          </label>
                        </td>
                        <td>
                          
                          :
                          <TextInput
                            type="text"
                            name="address"
                            value={address}
                            required
                            errorMessage={{ required: "Alamat harus diisi" }}
                            onChange={this.inputHandler}
                            className="add-vaccine-input"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label htmlFor="" className="label-update">
                            No. Telp
                          </label>
                        </td>
                        <td>
                          
                          :
                          {/* type="tel", not type="number" - a number input
                              blanks its own value for anything that is not a
                              valid float, so an existing "+62 812-..." would
                              load, read back empty, and silently wipe the
                              nurse's WhatsApp number on save. */}
                          <TextInput
                            type="tel"
                            value={phonenumber}
                            name="phonenumber"
                            required
                            errorMessage={{
                              required: "No. telp harus diisi",
                              validator:
                                "Nomor WhatsApp tidak valid. Contoh: 081234567890",
                            }}
                            validator={this.validPhoneNumber}
                            onChange={this.inputHandler}
                            className="add-vaccine-input"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="patient-buttons">
                    <button
                      type="submit"
                      className="btn btn-primary mr-1"
                      disabled={this.state.isSaving}
                    >
                      {this.state.isSaving ? "Menyimpan..." : "Simpan"}
                    </button>
                    <Link to="/users">
                      <button type="button" className="btn btn-danger mr-1">
                        Batal
                      </button>
                    </Link>
                  </div>
                </ValidationForm>
              </div>
            </div>
          </div>
        </LoadingOverlay>
      </>
    );
  }
}
export default UpdateUser;
